// extracted by mini-css-extract-plugin
export default {"routeName":"TrainAutoCompleteResult_routeName__xalV8"};